// Formatting for Pixta's Support API values (amounts come as "123.45" strings, dates as ISO 8601)
export const formatMoney = (value, locale) =>
  new Intl.NumberFormat(locale, { style: 'currency', currency: 'BRL' }).format(
    Number(value || 0)
  );

export const formatDate = (value, locale) =>
  value
    ? new Date(value).toLocaleString(locale, {
        dateStyle: 'short',
        timeStyle: 'short',
      })
    : '';

export const STATUS_COLORS = {
  paid: 'teal',
  waiting: 'amber',
  pending: 'amber',
  cancelled: 'ruby',
  expired: 'slate',
};

export const WITHDRAWAL_COLORS = {
  paid: 'teal',
  pending: 'amber',
  failed: 'ruby',
};
